// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import * as firebase from 'firebase';
import 'firebase/firestore';

export const environment = {
  // Produccion
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyAK0Cyj-j2cS9K28_yRstteofh2M2BsjTg",
  authDomain: "fm-sentinel-app.firebaseapp.com",
  projectId: "fm-sentinel-app",
  storageBucket: "fm-sentinel-app.appspot.com",
  messagingSenderId: "735251435038",
  appId: "1:735251435038:web:dfc681c633c7b3f5f1e80f"
  }
  //dev
  // production: false,
  // firebaseConfig: {
  //   apiKey: "AIzaSyDCpS8eFWqCKW8cFahXvIUGKglfuivHKww",
  //   authDomain: "femsanotificationdev.firebaseapp.com",
  //   databaseURL: "https://femsanotificationdev.firebaseio.com",
  //   projectId: "femsanotificationdev",
  //   storageBucket: "femsanotificationdev.appspot.com",
  //   messagingSenderId: "999511402172",
  //   appId: "1:999511402172:web:83e82322e82919419092b9",
  //   measurementId: "G-H30RMJC9HC"
  // }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
